module.exports = __webpack_public_path__ + "static/media/PrivatePage.29e748d0.png";